<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <el-table :data="getClientList">
          <el-table-column sortable prop="company" label="Client Name"></el-table-column>
          <el-table-column sortable label="Contact Name">
            <template slot-scope="scope">{{ scope.row.first_name + ' ' + scope.row.last_name }}</template>
          </el-table-column>
          <el-table-column label width="250">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="'This will allow you to login as the client.'"
                placement="left"
              >
                <el-button @click="emulateClient(scope.row.general_id)">Login as Client</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="'Client Settings'" placement="top">
                <el-button @click="clientSettings(scope.row.general_id)">
                  <i class="el-icon-setting"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from '../../shared/axios';
import { mapGetters, mapActions } from 'vuex';
export default {
  computed: {
    ...mapGetters('distributor', ['getClientList'])
  },
  created() {
    this.fetchClients().then(r => {
      // do something
    });
  },
  methods: {
    ...mapActions('distributor', ['fetchClients']),
    ...mapActions('auth', ['emulate']),
    emulateClient(id) {
      axios.get('client/emulate/' + id).then(r => {
        console.log(r);
        this.emulate(r.data);
        location.href = '/dashboard';
      });
    },
    clientSettings(id) {
      this.$router.push('/client/settings/' + id);
    }
  }
};
</script>
